/**
 * Vehicle allocation values
 */
export enum VehicleAllocationEnum {
	RENTAL = 'rental',
}
